import _ from 'lodash'

export const CHECK_VALUE = function (value:any) {
    let result = false;
    if (value !== undefined && value !== '' && value !== null) {
        result = true;
    }
    return result
};

export const CHECK_INTEGER = function (value:any) {
    let result = false;
    if (CHECK_VALUE(value)) {
        const intRegExp = new RegExp(/^[-+]?\d+$/gm);
        result = intRegExp.test(value);
    }
    return result
};

export const CHECK_POSITIVE_INTEGER = function (value:any) {
    let result = false;
    if (CHECK_VALUE(value)) {
        const posIntRegExp = new RegExp(/\d+$/gm);
        result = posIntRegExp.test(value);
    }
    return result
};

export const CHECK_DATE_OBJ = function (dateObj:any) {
    let result = false;
    if (CHECK_VALUE(dateObj)) {
        result = dateObj instanceof Date;
    }
    return result;
};

export const CHECK_NON_EMPTY_ARRAY = function (data:any) {
    return data && _.isArray(data) && _.isEmpty(data) !== true;
};

export const CHECK_NON_EMPTY_DICTIONARY = function (data:any) {
    return data && _.isObject(data) && _.isArray(data) !== true && _.isEmpty(data) !== true;
};

export const CHECK_EMAIL_FORMAT = function (email:any) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}